module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "haven.afa0b7eb.svg";